import store from '@/store'

const getPath = (mod, id) => {
  const arr = Array.isArray(id) ? id : [id]

  const accountId = store.getters.getAccount._id
  return ['formsave', accountId, mod, ...arr].filter(v => v).join('/')
}

const sync = (self, mod, id, dataPath, saveIf = (v) => v) => {
  const path = getPath(mod, id)

  // $watch data
  self.$watch(dataPath, {
    deep: true,
    handler: (value) => {
      if (saveIf(value)) {
        const data = JSON.stringify(value)
        localStorage.setItem(path, data)
        // console.log('save', path)
      } else {
        localStorage.removeItem(path)
        // console.log('remove', path)
      }
    }
  })

  // set data
  const data = localStorage.getItem(path)
  if (data) {
    self[dataPath] = JSON.parse(data)
    // console.log('restore', path)
  }

  return {
    remove: () => {
      // console.log('remove', path)
      localStorage.removeItem(path)
    }
  }
}

export default {
  sync
}



// WEBPACK FOOTER //
// ./src/utils/Formsave.js